"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeAnimations = void 0;
const color_1 = require("@urpflanze/color");
const createAnimation_1 = require("./createAnimation");
const utilities_1 = require("./utilities");
/**
 *
 * @category Utilities
 * @export
 * @param {Array<ISimpleAnimation>} simpleAnimations
 * @return {*}  {(((currentTime: number) => string | number | Array<string | number> | undefined) | undefined)}
 */
function composeAnimations(simpleAnimations) {
    const animations = simpleAnimations.map(createAnimation_1.createAnimation).filter(a => typeof a !== 'undefined');
    const animationsLength = animations.length;
    if (animationsLength > 0) {
        return (currentTime) => {
            let value = undefined;
            for (let i = 0; i < animationsLength; i++) {
                const animation = animations[i];
                animation.update(currentTime);
                value = typeof value === 'undefined' ? animation.value : interpolate(value, animation.value);
            }
            return value;
        };
    }
}
exports.composeAnimations = composeAnimations;
function interpolate(a, b, offset = 0.5) {
    const from = Array.isArray(a) ? a : [a];
    const to = Array.isArray(b) ? b : [b];
    const results = [];
    for (let i = 0, len = from.length; i < len; i++) {
        if (typeof from[i] !== typeof to[i]) {
            console.error('[@urpflanze/animation]: cannot interpolate');
            return undefined;
        }
        else {
            if (typeof from[i] !== 'string') {
                const a = from[i], b = to[i];
                results.push(a + offset * (b - a));
            }
            else {
                const a = from[i];
                const b = to[i];
                const parsed_a = color_1.parseColorAndConvert(a);
                const parsed_b = color_1.parseColorAndConvert(b);
                if (typeof parsed_a !== 'undefined' && typeof parsed_b !== 'undefined') {
                    results.push(utilities_1.interpolateColorRGB(parsed_a, parsed_b, offset));
                }
            }
        }
    }
    return results.length === 1 ? results[0] : results;
}
//# sourceMappingURL=composeAnimations.js.map